import type { PinnedConnector } from '@erikdakoda/site-template-ui/types';

/** Curated Connections pin list for uvilo-ai (themeConfig.pinnedConnectors). Order: OS → Cloud → Composio. */
export const UVILO_PINNED_CONNECTORS: readonly PinnedConnector[] = [
  {
    connectorKey: 'healthkit',
    kind: 'os',
    name: 'HealthKit',
    logo: 'https://res.cloudinary.com/uvilo/image/upload/t_128x128_icon/v1785878336/Platforms/apple_health_dark.png',
  },
  {
    connectorKey: 'health-connect',
    kind: 'os',
    name: 'Health Connect',
    logo: 'https://res.cloudinary.com/uvilo/image/upload/t_128x128_icon/f_auto/q_auto/Platforms/health_connect_light.png',
  },
  {
    connectorKey: 'oura',
    kind: 'cloud',
    name: 'Oura',
    logo: 'https://res.cloudinary.com/uvilo/image/upload/t_128x128_icon/v1785718775/Platforms/oura_dark.png',
  },
  { connectorKey: 'gmail', kind: 'composio', name: 'Gmail', logo: '' },
  { connectorKey: 'googlecalendar', kind: 'composio', name: 'Google Calendar', logo: '' },
  { connectorKey: 'outlook', kind: 'composio', name: 'Outlook', logo: '' },
  { connectorKey: 'todoist', kind: 'composio', name: 'Todoist', logo: '' },
  { connectorKey: 'googletasks', kind: 'composio', name: 'Google Tasks', logo: '' },
];
